// extracted by mini-css-extract-plugin
module.exports = {"container":"JobsManager_container__1E1tm","jobsText":"JobsManager_jobsText__3POC1"};